import styled from 'styled-components'

const SingleProjectStyle = styled.div`
	.fileSectionWrap {
		margin-top: var(--secToTextSecToFooterDistance);
	}

	.moreWorks {
		margin-bottom: var(--relatedTitleDistance);
	}
`

export default SingleProjectStyle
